import type { ReactNode } from "react";
import { SectionReveal } from "./SectionReveal";

interface PageIntroProps {
  eyebrow: string;
  title: string;
  text: string;
  aside?: ReactNode;
}

export function PageIntro({ eyebrow, title, text, aside }: PageIntroProps) {
  return (
    <SectionReveal className="grid gap-6 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,0.95fr)] lg:items-end">
      <div className="space-y-4">
        <p className="text-sm uppercase tracking-[0.18em] text-teal-800">{eyebrow}</p>
        <h1 className="font-display max-w-[13ch] text-[clamp(2.45rem,7vw,5.8rem)] leading-[0.92] tracking-[-0.06em] text-balance md:max-w-[11ch]">
          {title}
        </h1>
      </div>
      <div className="space-y-4 lg:justify-self-end">
        <p className="max-w-[60ch] text-lg leading-8 text-stone-600">{text}</p>
        {aside}
      </div>
    </SectionReveal>
  );
}
